import { watch } from 'vue';
import useUserService from './apiServices/useUserService';
import * as Sentry from '@sentry/vue';

const useSentryConfig = () => {
  const { details, attributes } = useUserService();
  const { data: detailsData } = details();
  const { data: attributesData } = attributes();

  watch(
    () => detailsData.value?.id,
    (newDetails) => {
      if (!newDetails) {
        Sentry.setUser(null);
      }
      Sentry.setUser({
        id: detailsData.value?.id,
        email: detailsData.value?.address
      });
    }
  );

  watch([() => detailsData.value, () => attributesData.value], ([details, attributes]) => {
    Sentry.setContext('appearance', {
      inboxType: details?.meta.inboxType,
      displayDensity: details?.meta.displayDensity,
      view_mode: details?.view_mode,
      threadingShownState: attributes?.threadingShownState,
      disabledFeatures: attributes?.disabledFeatures,
      markAsReadTime: attributes?.markAsReadTime,
      outsideContent: attributes?.outsideContent,
      contactOrdering: attributes?.contactOrdering
    });
  });
};

export default useSentryConfig;
